const TmpL003 = (page, section) => {
  // pull images data from the page
  const images = [];
  const media = [];
  const eMentors = [];
  const modifiedPage = {
    ...page
  };

  page.content.core.forEach((slide, index) => {
    // modify the media object from the page data
    const slideMedia = {
      size: '1920px X 1080px',
      ...slide.media,
      id: page.id + '-' + index,
      page: page.id,
      src: page.label.toLowerCase().replaceAll('-', '_') + '_' + index + '.jpg'
    };
    // add the media object to the media array
    media.push(slideMedia);
    // modify the media object to strip out the unnecessary data
    delete slideMedia.author_desc_en;
    delete slideMedia.author_desc_tl;
    delete slideMedia.transcript;
    delete slideMedia.display_content;
    delete slideMedia.media_url;
    // push the modified media object to the images array
    images.push(slideMedia);
    // update the media object in te modified page data
    modifiedPage.content.core[index].media = slideMedia;
  });

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id
      };
      eMentors.push(eMentor);
    });
  }

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: images || [],
    materials: [],
    eMentor: eMentors,
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpL003;
